var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignBlack24Dp1X(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35F34B6A-41A8-4B88-B7F2-33CD886D517B@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-36.000000, -701.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "campaign_black_24dp",
    transform: "translate(36.000000, 701.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,11 C18,11.67 18,12.33 18,13 C19.2,13 20.76,13 22,13 C22,12.33 22,11.67 22,11 C20.76,11 19.2,11 18,11 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,17.61 C16.96,18.32 18.21,19.26 19.2,20 C19.6,19.47 20,18.93 20.4,18.4 C19.41,17.66 18.16,16.72 17.2,16 C16.8,16.54 16.4,17.08 16,17.61 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,5.6 C20,5.07 19.6,4.53 19.2,4 C18.21,4.74 16.96,5.68 16,6.4 C16.4,6.93 16.8,7.47 17.2,8 C18.16,7.28 19.41,6.35 20.4,5.6 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,9 C2.9,9 2,9.9 2,11 L2,13 C2,14.1 2.9,15 4,15 L5,15 L5,19 L7,19 L7,15 L8,15 L13,18 L13,6 L8,9 L4,9 Z M9.03,10.71 L11,9.53 L11,14.47 L9.03,13.29 L8.55,13 L8,13 L4,13 L4,11 L8,11 L8.55,11 L9.03,10.71 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,12 C15.5,10.67 14.92,9.47 14,8.65 L14,15.34 C14.92,14.53 15.5,13.33 15.5,12 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignBlack24Dp1X);
export default __webpack_public_path__ + "static/media/campaign_black_24dp@1x.029f22c61804130594b075520546a6b9.svg";
export { ForwardRef as ReactComponent };